<template>
  <div
    class="botBei"
    style="background: #2a3134"
    :style="{
      'font-size': $px2rem(`${16}px`),
    }"
  >
    <div class="compTit">深圳市龙胤网络科技有限公司</div>
    <img src="@/assets/beian.png" class="beianImg" alt="" />
    <a
      class="beiTitle"
      href="https://beian.miit.gov.cn/#/Integrated/index"
      target="_blank"
      >粤公网安备44030002002897号</a
    >
    <a
      class="beiTitle-1"
      href="https://beian.miit.gov.cn/#/Integrated/index"
      target="_blank"
      >粤ICP备2023005051号-5</a
    >
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.botBei {
  height: 105px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  position: relative;
}
.beianImg {
  width: 18px;
  height: 17px;
  margin-left: 61px;
}
.compTit {
  color: #ffffff;
  padding-right: 64px;
  border-right: 1px solid rgba(255, 255, 255, 0.16);
  letter-spacing: 2px;
  font-size: 16px;
}
.beiTitle {
  margin-left: 5px;
  color: #aaaaaa;
  letter-spacing: 2px;
  font-size: 16px;
}

.beiTitle-1 {
  margin-left: 40px;
  color: #aaaaaa;
  letter-spacing: 2px;
  font-size: 16px;
}
</style>
